import Phaser from "phaser";
import { BootScene } from "./scenes/BootScene";
import { MenuScene } from "./scenes/MenuScene";
import { GameScene } from "./scenes/GameScene";
import { UIScene } from "./scenes/UIScene";
import { SkillTreeScene } from "./scenes/SkillTreeScene";
import { LeaderboardScene } from "./scenes/LeaderboardScene";
import { AchievementsScene } from "./scenes/AchievementsScene";
import { SignInScene } from "./scenes/SignInScene";
import { ProfileScene } from "./scenes/ProfileScene";
import { FriendsScene } from "./scenes/FriendsScene";
import { MapSelectScene } from "./scenes/MapSelectScene";
import { CampaignScene } from "./scenes/CampaignScene";
import { QuestScene } from "./scenes/QuestScene";
import { SettingsScene } from "./scenes/SettingsScene";
import { MapEditorScene } from "./scenes/MapEditorScene";
import { SpriteShowerScene } from "./scenes/SpriteShowerScene";
import { TransitionScene } from "./scenes/TransitionScene";
import { GAME_HEIGHT, GAME_WIDTH } from "./config";

// With pixelArt: false + antialias: true the procedural frames and webfont
// text stay crisp when the canvas is upscaled to 1080p / 1440p / 4K via the
// FIT scale mode. (Phaser 3.5+ no longer honors the legacy `resolution`
// field, so we just rely on antialiased upscaling.)
const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: "game",
  width: GAME_WIDTH,
  height: GAME_HEIGHT,
  backgroundColor: "#2b1d10",
  pixelArt: false,
  antialias: true,
  antialiasGL: true,
  roundPixels: true,
  physics: {
    default: "arcade",
    arcade: { gravity: { x: 0, y: 0 }, debug: false }
  },
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH
  },
  render: {
    powerPreference: "high-performance"
  },
  // TransitionScene is last so it starts above the rest; it also calls
  // bringToTop() on create, since scenes started later would otherwise cover it.
  scene: [BootScene, MenuScene, CampaignScene, MapSelectScene, MapEditorScene, SpriteShowerScene, SettingsScene, QuestScene, GameScene, UIScene, SkillTreeScene, LeaderboardScene, AchievementsScene, SignInScene, ProfileScene, FriendsScene, TransitionScene]
};

const game = new Phaser.Game(config);

declare global {
  interface Window {
    __MITTELALTE_GAME__?: Phaser.Game;
  }
}

// Read-only test hook for the local lifecycle smoke runner. Production builds
// do not expose the Phaser instance.
if (import.meta.env.DEV) window.__MITTELALTE_GAME__ = game;
